/**
 * LINE Block Log API Service
 */
import apiClient from '../axios.js';

export default {
  /**
   * 查詢封鎖記錄列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁數量
   * @param {string} params.eventType - 事件類型（blocked, unblocked）
   * @param {string} params.memberId - 會員 ID
   * @param {string} params.lineUserId - LINE User ID
   * @returns {Promise}
   */
  async list(params = {}) {
    const response = await apiClient.get('/line/block-logs', { params });
    return response;
  },

  /**
   * 查詢封鎖統計
   * @param {Object} params - 查詢參數
   * @param {string} params.startDate - 開始日期（ISO 8601 格式）
   * @param {string} params.endDate - 結束日期（ISO 8601 格式）
   * @returns {Promise}
   */
  async getStatistics(params = {}) {
    const response = await apiClient.get('/line/block-statistics', { params });
    return response;
  },

  /**
   * 查詢會員封鎖資訊
   * @param {string} memberId - 會員 ID
   * @returns {Promise}
   */
  async getBlockInfo(memberId) {
    const response = await apiClient.get(`/line/block-info/${memberId}`);
    return response;
  }
};
